import { app } from '../../app';

app.config(config);

/** @ngInject */
function config(stConfig) {
    stConfig.pagination.displayedPages = 1;
    stConfig.pagination.template = require('./pagination/st-pagination.template.html');
    stConfig.search.inputEvent = 'input change';
    stConfig.select.selectedClass = 'st-selected active';
    stConfig.select.mode = 'multiple';
}



// WEBPACK FOOTER //
// ./src/portal/components/smart-table/smart-table.config.js